import React, { useEffect } from "react";
import { DPComponentLoader, DPEmptyTable, DPTable } from "Components/DP";
import { Header } from "Components/DP/DPTable/DPTable";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import OriginalSubmissionHeadCell from "../OriginalSubmissionHeadCell/OriginalSubmissionHeadCell";
import ProcessedSubmissionHeadCell from "../ProcessedSubmissionHeadCell/ProcessedSubmissionHeadCell";
import { useBatchDisbursements } from "./useBatchDisbursements";
import {
  BatchDisbursementRow,
  canApproveDisbursementFile,
} from "./BatchDisbursementRow/BatchDisbursementRow";
import DisbursementStatusHeadCell from "Components/Shared/DisbursementStatusHeadCell/DisbursementStatusHeadCell";

const disbursementsFilesTableColumns = [
  { header: "Date/Time", width: 12 },
  { header: "Uploader", width: 16 },
  { header: "File Name", width: 16 },
  {
    header: <DisbursementStatusHeadCell />,
    width: 16,
  },
  { header: <OriginalSubmissionHeadCell />, width: 13 },
  { header: <ProcessedSubmissionHeadCell />, width: 13 },
  { header: { label: "Action", align: "center" }, width: 14 },
];

export const DisbursementsFilesTable = () => {
  const { employer } = usePartnerConfig();
  const colWidths = disbursementsFilesTableColumns.map(({ width }) => width);
  const headers = disbursementsFilesTableColumns.map(({ header }) => header);

  const {
    batchDisbursements,
    loading,
    page,
    rowsPerPage,
    handlePageChange,
  } = useBatchDisbursements();

  useEffect(() => {
    if (batchDisbursements?.items && employer) {
      const filesForApprovalCount = batchDisbursements.items.filter(
        disbursement => canApproveDisbursementFile(disbursement, employer)
      ).length;

      AmplitudeProvider.logEvent({
        type: AmplitudeEventType.FileUploadPageViewed,
        payload: {
          type: "cycle",
          numberOfActions: filesForApprovalCount,
        },
      });
    }
  }, [batchDisbursements?.items, employer]);

  return (
    <DPTable
      headers={headers as Header[]}
      colWidths={colWidths}
      page={page}
      rowsPerPage={rowsPerPage}
      count={batchDisbursements?.totalCount}
      onChangePage={handlePageChange}
    >
      <DPComponentLoader
        isLoading={loading}
        kind={"table"}
        awaitComponent={
          batchDisbursements?.totalCount ? (
            <>
              {batchDisbursements.items.map(disbursement => (
                <BatchDisbursementRow key={disbursement.id} {...disbursement} />
              ))}
            </>
          ) : (
            <DPEmptyTable message={"Batch Disbursement Files will appear here once uploaded"} />
          )
        }
      />
    </DPTable>
  );
};
